module.exports = __webpack_public_path__ + "img/Person-with-Bag.b70729d4.svg";